import { useUser } from '@stackframe/react';
import { isNeonAuthEnabled } from '@/utils/auth.utils';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  // If Neon Auth is not enabled, allow access (no auth required)
  if (!isNeonAuthEnabled) {
    return <>{children}</>;
  }

  // Auth is enabled - use the auth-aware component
  return <ProtectedRouteWithAuth>{children}</ProtectedRouteWithAuth>;
};

// Separate component that calls useUser - only rendered when auth is enabled
function ProtectedRouteWithAuth({ children }: ProtectedRouteProps) {
  const user = useUser({ or: 'redirect' });

  // While loading user data, show nothing (Stack handles the redirect)
  if (!user) {
    return null;
  }

  // User is authenticated, render protected content
  return <>{children}</>;
}
